export default function task() {
    return {
        taskState(status) {
            return status ? 'Completed' : 'Pending';
        },
        statusColor(status) {
            return status ? 'btn-success' : 'btn-danger';
        },
        toggleStatus($event, id) {
            Swal.fire({
			    title: "Are you sure ?",
			    text: "You will change the status of this task.",
			    type: "warning",
			    showCancelButton: true,
			    confirmButtonText: "Yes, change it !",
			    cancelButtonText: "No, cancel !",
			    closeOnConfirm: false,
			    closeOnCancel: false
			  }).then((confirmed) => {
			  	console.log(confirmed);
			    if (confirmed.value == true) {
			      	axios.get(`/api/tasks/${id}/toggle`).then(response => {
		                $event.toElement.innerHTML = this.taskState(response.data.data.task.status);
		            	showSwal('successful-opperation', 'Task marked as ' + this.taskState(response.data.data.task.status));
		            }, error => {
		            	showSwal('something-wrong', '');
		            });
			    } else if(confirmed.dissmiss == "cancel") {
                    Swal.fire("Cancelled", "Status Unchanged !", "error");
			    }
		  	});

        },
    }
}
